/**
 * Sección compacta de Configuración: encabezado de una línea (título,
 * descripción breve y acción principal) y el contenido debajo.
 * Todas las pestañas de Configuración la usan para verse consistentes.
 *
 * @component
 * @param {Object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {string} [props.icon] - Clase de Font Awesome (p. ej. 'fa-flag').
 * @param {React.ReactNode} [props.actions] - Botones a la derecha del título.
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
const SettingsSection = ({ title, description, icon, actions, children }) => (
  <section className="ss">
    <header className="ss-head">
      <div className="ss-titles">
        <h6 className="ss-title">
          {icon && <i className={`fa-solid ${icon}`} />}
          {title}
        </h6>
        {description && <p className="ss-desc">{description}</p>}
      </div>
      {actions && <div className="ss-actions">{actions}</div>}
    </header>
    <div className="ss-body">{children}</div>

    <style>{`
      .ss { display: flex; flex-direction: column; gap: 12px; }
      .ss + .ss { margin-top: 20px; padding-top: 16px; border-top: 1px solid var(--gm-border); }
      .ss-head { display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: space-between; gap: 10px; }
      .ss-titles { min-width: 0; }
      .ss-title {
        display: flex; align-items: center; gap: 8px; margin: 0;
        font-size: 0.95rem; font-weight: 700; color: var(--gm-text);
      }
      .ss-title i { font-size: 0.85rem; color: var(--gm-primary); }
      .ss-desc { margin: 2px 0 0; font-size: 0.8rem; color: var(--gm-text-muted); }
      .ss-actions { display: flex; flex-wrap: wrap; gap: 6px; }
      .ss-actions .btn { font-size: 0.8rem; border-radius: 8px; }
    `}</style>
  </section>
)

export default SettingsSection
